import { SettingsObject } from '@hooks/useSettings';
import { getMarketData } from '@utils/getMarketData';
import { MarketName } from 'lib/global';

export const cteDefaults = (market: MarketName): Partial<SettingsObject> => {
    const { country, language } = getMarketData(market);
    const websiteBase = 'https://www.cte.ikeadt.com';
    return {
        baseUrl: 'https://www.cte.ikeadt.com',
        discountsAPI: {
            enableDeliveryOffersAddon: false,
            endpoint: 'https://web-api.cte.ikeadt.com/wdm/api/discounts/get',
        },
        giftRegistryEndpoint: 'https://igift.test.ingkadt.com/graphql',
        listClientId: '14adf7f9-23af-480e-98fd-8131e423daea',
        listEndpoint: 'https://dev.favs.oneweb.ingkadt.com/graphql',
        listingFragmentsUrl: `/${country}/${language}/listing/fragments/product-rec-carousel/`,
        optimizelyBase: 'https://www.cte.ikeadt.com',
        optimizelyKey: 'CwVNQ9rGUcVFbEJYcfZzv',
        profileClientId: '659e0e38-0474-4276-b647-9fa0eb33e982',
        profileEndpoint: 'https://api.ingka.ppe.ikeadt.com/api/profile/icm',
        showDevModal: true,
        sunClientId: '7dbe0b5a-47d8-472e-9205-f79d478697ef',
        sunEndpoint: 'https://api.salesitem.ingkadt.com/notifications/signup',
        sunPrivacyPolicyLink: `${websiteBase}/${country}/${language}/customer-service/privacy-policy/`,
        websiteBase,
    };
};
